
    import { computed, defineComponent, onBeforeMount } from 'vue'

    import { useHeadful } from '@/common/composables/libs/headful'
    import { useI18n } from 'vue-i18n-composable'
    import StaffList from '@/app/components/common/staff/StaffList.vue'

    import { useBreadcrumbsStore } from '@/app/stores/breadcrumbs'
    import { useStaffStore } from '@/app/stores/staff'

    export default defineComponent({
        components: {
            StaffList
        },
        setup () {
            const headful = useHeadful()
            const i18n = useI18n()
            const staffStore = useStaffStore()

            const editorialCollege = computed(() => staffStore.editorialCollege)

            onBeforeMount(async (): Promise<void> => {
                useBreadcrumbsStore().set([
                    { text: i18n.t('nav.about.about').toString(), to: { name: 'about' } },
                    { text: i18n.t('nav.about.editorial-college').toString() }
                ])

                headful({
                    title: `${i18n.t('nav.about.editorial-college')} | ${i18n.t('meta.title')}`
                })

                await staffStore.loadEditorialCollege()
            })

            return {
                editorialCollege
            }
        }
    })
